'use client';

import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';

interface SidebarLayoutWrapperProps {
  children: React.ReactNode;
}

export default function SidebarLayoutWrapper({ children }: SidebarLayoutWrapperProps) {
  const pathname = usePathname();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // Don't apply sidebar padding on login pages
  const isLoginPage = pathname === '/admin-login' || pathname === '/login' || pathname === '/authentication-login';

  // Sync with localStorage
  useEffect(() => {
    const savedState = localStorage.getItem('sidebarOpen');
    if (savedState !== null) {
      setIsSidebarOpen(savedState === 'true');
    }

    // Listen for storage changes
    const handleStorageChange = () => {
      const savedState = localStorage.getItem('sidebarOpen');
      if (savedState !== null) {
        setIsSidebarOpen(savedState === 'true');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Custom event for same-tab updates
    const handleSidebarToggle = () => {
      const savedState = localStorage.getItem('sidebarOpen');
      if (savedState !== null) {
        setIsSidebarOpen(savedState === 'true');
      }
    };

    window.addEventListener('sidebarToggle', handleSidebarToggle);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('sidebarToggle', handleSidebarToggle);
    };
  }, []);

  if (isLoginPage) {
    return <>{children}</>;
  }

  return (
    <div data-component-id="src/components/common/SidebarLayoutWrapper.tsx:55:4" data-component-path="src/components/common/SidebarLayoutWrapper.tsx" data-component-line="55" data-component-end-line="61" data-component-file="SidebarLayoutWrapper.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
      className={`min-h-screen pt-16 transition-all duration-300 ${
        isSidebarOpen ? 'lg:pl-64' : 'lg:pl-16'
      }`}
    >
      {children}
    </div>
  );
}